import React from 'react';
import { BarChart2Icon } from 'lucide-react';
interface ChickenRow {
  name: string;
  low: string;
  avg: string;
  high: string;
}
const chickenData: ChickenRow[] = [{
  name: 'National Composite',
  low: '$1.24',
  avg: '$1.29',
  high: '$1.50'
}, {
  name: '3.00 LB and Lighter',
  low: '$1.26',
  avg: '$1.29',
  high: '$1.32'
}, {
  name: '3.01 LB and heavier',
  low: '$1.24',
  avg: '$1.29',
  high: '$1.50'
}];
export function ChickenPricingTable() {
  return <div className="mb-12" data-id="element-31">
      <div className="mb-4" data-id="element-32">
        <div className="flex items-center gap-2 mb-1" data-id="element-33">
          <BarChart2Icon className="w-5 h-5 text-gray-700" data-id="element-34" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-35">
            Whole Body Trading by Size
          </h3>
        </div>
        <p className="text-sm text-gray-500" data-id="element-36">Price Representation – $/lb</p>
      </div>

      <div className="overflow-x-auto" data-id="element-37">
        <table className="w-full text-sm" data-id="element-38">
          <thead data-id="element-39">
            <tr className="border-b border-gray-200" data-id="element-40">
              <th className="text-left py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-41">
                Type
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-400" data-id="element-42">
                Low
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-43">
                Avg
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-400" data-id="element-44">
                High
              </th>
            </tr>
          </thead>
          <tbody data-id="element-45">
            {/* Section header */}
            <tr className="border-b border-gray-100 bg-gray-50" data-id="element-46">
              <td colSpan={4} className="py-3 px-4 font-semibold text-gray-900" data-id="element-47">
                Whole Body Trading by Size
              </td>
            </tr>
            {chickenData.map((row, idx) => <tr key={idx} className="border-b border-gray-100" data-id="element-48">
                <td className="py-4 px-4 text-gray-900 font-medium" data-id="element-49">
                  {row.name}
                </td>
                <td className="py-4 px-4 text-right text-gray-500" data-id="element-50">
                  {row.low}
                </td>
                <td className="py-4 px-4 text-right font-bold text-gray-900 text-base" data-id="element-51">
                  {row.avg}
                </td>
                <td className="py-4 px-4 text-right text-gray-500" data-id="element-52">
                  {row.high}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Deep Dive Link */}
      <div className="mt-4 flex justify-end" data-id="element-53">
        <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-[#002f5f] hover:underline flex items-center gap-1" data-id="element-54">
          View Detailed Analysis
          <BarChart2Icon className="w-3 h-3" data-id="element-55" />
        </a>
      </div>
    </div>;
}